import React from 'react';

import Download from 'crehana-icons/Download';
import Loader from 'crehana-ui/Loader';

import TrailerPlayer from 'Jsx/Shared/TrailerPlayer';
import CopyButton from 'Jsx/Shared/CopyButton';

import useAffiliateUrl from 'Jsx/CourseDetail/hooks/useAffiliateUrl';

import { MaxContainer } from './Player.styles';

const Player = ({
  originalId,
  title,
  promoVideoHashedId,
  trailerDownloadUrl,
  promoImage,
  imagePlaceholder,
  trailerSource,
  userIsAffiliate,
}) => {
  const { loading, affiliateUrl } = useAffiliateUrl(originalId.toString());

  if (loading) {
    return (
      <MaxContainer className="flex items-center justify-center">
        <Loader />
      </MaxContainer>
    );
  }

  return (
    <MaxContainer className="bg-black flex items-center justify-center">
      {userIsAffiliate && affiliateUrl && (
        <div className="affiliate-actions">
          <div className="copy-button">
            <CopyButton
              color="#222"
              textToCopy={affiliateUrl}
              iconSize={18}
              wrapperStyles={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              tooltipWrapperStyles={{
                top: 47,
                left: 0,
              }}
              hideArrow
            />
          </div>
          <div className="download-trailer">
            <a
              aria-label="Descargar el trailer"
              href={trailerDownloadUrl}
              target="_blank"
              rel="noreferrer noopener"
            >
              <Download color="#ffffff" size={18} />
            </a>
          </div>
        </div>
      )}
      <TrailerPlayer
        courseId={originalId}
        title={title}
        promoVideoHashedId={promoVideoHashedId}
        promoImage={promoImage}
        imagePlaceholder={imagePlaceholder}
        trailerSource={trailerSource}
        autoplay
        withUserActivityTrack
      />
    </MaxContainer>
  );
};

export default Player;
